import types from './actionTypes';

/**
 * The live view of the agent's conversations. A store of its own and not a
 * part of aiConversations: the single-lead modal resets that whole store when
 * it closes, and opening it from this view would blank the list underneath.
 */
const initialState = {
  // Until the first live snapshot arrives.
  loading: false,
  // starting / waiting / active, stopped ones excluded, oldest first.
  live: [],
  // Every conversation started since local midnight, for the counts.
  today: [],
  // leadId -> { id, name, phone }, filled in groups as the list grows.
  leads: {},
  // A take-back or a stop is in flight.
  acting: false,
  // The last take-back or stop that failed.
  error: '',
  // The two listeners, each on its own: a failed read must say so on screen,
  // or it shows as zero conversations, which reads as a fact.
  liveError: '',
  todayError: '',
};

const errorMessage = (error) => (error && error.message) || String(error);

const aiConversationMonitorReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.RESET_AI_CONVERSATION_MONITOR_STATE:
      return { ...initialState };

    case types.SYNC_LIVE_AI_CONVERSATIONS.REQUEST:
      return { ...state, loading: true, liveError: '' };

    case types.SYNC_LIVE_AI_CONVERSATIONS.SUCCESS:
      return {
        ...state,
        loading: false,
        liveError: '',
        live: [...action.conversations],
      };

    case types.SYNC_TODAY_AI_CONVERSATIONS.REQUEST:
      return { ...state, todayError: '' };

    case types.SYNC_TODAY_AI_CONVERSATIONS.SUCCESS:
      return { ...state, todayError: '', today: [...action.conversations] };

    case types.FETCH_MONITOR_LEADS.SUCCESS:
      return {
        ...state,
        leads: {
          ...state.leads,
          ...Object.fromEntries(action.leads.map((lead) => [lead.id, lead])),
        },
      };

    case types.TAKE_BACK_AI_CONVERSATIONS.REQUEST:
    case types.STOP_ALL_AI_CONVERSATIONS.REQUEST:
      return { ...state, acting: true, error: '' };

    // The live list is not touched: the listener knows what the callable
    // actually stopped, and a row removed here could hide one it left alone.
    case types.TAKE_BACK_AI_CONVERSATIONS.SUCCESS:
    case types.STOP_ALL_AI_CONVERSATIONS.SUCCESS:
      return { ...state, acting: false };

    case types.TAKE_BACK_AI_CONVERSATIONS.FAILURE:
    case types.STOP_ALL_AI_CONVERSATIONS.FAILURE:
      return { ...state, acting: false, error: errorMessage(action.error) };

    case types.SYNC_LIVE_AI_CONVERSATIONS.FAILURE:
      return {
        ...state,
        loading: false,
        liveError: errorMessage(action.error),
      };

    // Typically the (countryId, startedAt) index not built yet: Firestore
    // refuses the query, and its message carries the link that creates it.
    case types.SYNC_TODAY_AI_CONVERSATIONS.FAILURE:
      return { ...state, todayError: errorMessage(action.error) };

    // Without names the view still works: the phone and the conversation are
    // on the row. The error is not worth hiding the list for.
    case types.FETCH_MONITOR_LEADS.FAILURE:
      return state;

    default:
      return state;
  }
};

export default aiConversationMonitorReducer;
